module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "approvalWaveStatusModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.AWS001) + " / " + _vm._s(_vm.lang.AWS002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.AWS003,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedWave = ''
      }
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projectsWaves), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select2', {
    ref: "waveSelect",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.AWS004,
      "allowClear": true,
      "disabled": !_vm.selectedProject
    },
    on: {
      "change": function($event) {
        return _vm.getWaveStatus()
      }
    },
    model: {
      value: (_vm.selectedWave),
      callback: function($$v) {
        _vm.selectedWave = $$v
      },
      expression: "selectedWave"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.availableWaves), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n                " + _vm._s(wave.WaveName) + "\n              ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Approval Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select2', {
    ref: "approvalStatusSelect",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.AWS036,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getWaveStatus()
      }
    },
    model: {
      value: (_vm.selectedApprovalStatus),
      callback: function($$v) {
        _vm.selectedApprovalStatus = $$v
      },
      expression: "selectedApprovalStatus"
    }
  }, [_c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "open"
    }
  }, [_vm._v("Open")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [(_vm.selectedWave && _vm.statusData.SurveyInstances) ? _c('table', {
    staticClass: "table outer-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.statusData.SurveyInstances && _vm.statusData.SurveyInstances.Status) ? _c('tr', [_c('td', {
    staticClass: "text-left noborder"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS005))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left noborder"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS006))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.SurveyInstances.Status.Count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS007))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Approval) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS008))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.InProgress) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS009))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Reporting) + "\n                        ")])]), _vm._v(" "), (_vm.statusData.Wave) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS010))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number((_vm.statusData.Wave.InTime * 100).toFixed(2))) + " %")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Approvals) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS011))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS012))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number((_vm.statusData.Approvals.None * 100).toFixed(2))) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS013))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number((_vm.statusData.Approvals.Open * 100).toFixed(2))) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS014))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number((_vm.statusData.Approvals.Approved * 100).toFixed(2))) + " %")])])])])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS015))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [(_vm.statusData.Shopper.Gender) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS016))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS017) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Shopper.Gender.Male * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS018) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Shopper.Gender.Female * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Divers:")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Shopper.Gender.Divers * 100).toFixed(2))) + " %\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Age) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS019))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS020) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Age.Min) + "\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS021) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Age.Max) + "\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS022) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Shopper.Age.Above70 * 100).toFixed(2))) + " %\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Distance) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS023))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS020) + ":")]), _vm._v("\n                          " + _vm._s((_vm.statusData.Shopper.Distance.Min / 1000).toFixed(0)) + " km\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS021) + ":")]), _vm._v("\n                          " + _vm._s((_vm.statusData.Shopper.Distance.Max / 1000).toFixed(0)) + " km\n                        ")]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Car) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS024))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS020) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Car.YearOfBuild.Min) + "\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS021) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Car.YearOfBuild.Max) + "\n                        ")]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (_vm.statusData.Model) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS025) + " (-|=|+)")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS026) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Model.Downgrade * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS027) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Model.Match * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS028) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Model.Upgrade * 100).toFixed(2))) + " %\n                        ")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.statusData.CarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS029))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CompetitorCarDistribution) ? _vm._l((_vm.getGroupedCompetitorCars()), function(competitorCarDistribution, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(competitorCarDistribution[0]) + " " + _vm._s(_vm.lang.AWS033))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('table', {
      staticClass: "table table-hover"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((competitorCarDistribution[1]), function(model, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                          ")])])
    }), 0)])])])
  }) : _vm._e()], 2)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.AWS034) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "70%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e1dd5a8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperApproval/ApprovalWaveStatusModal.vue
// module id = 1695
// module chunks = 1